exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-color[data-v-5541087a]{color:var(--systemMainColor)}", ""]);

// exports
